import {Buffer} from 'buffer';
import AES from 'crypto-js/aes';
import {enc, lib} from 'crypto-js/core';
import ZeroPadding from 'crypto-js/pad-zeropadding';

import log from '@/services/logger/log';
import tncService from '@/services/tncService';

const encryptDeviceSerialNumber = (deviceSerialNumber) => {
    const intToken = tncService.getIntToken();

    if (deviceSerialNumber && intToken) {
        try {
            const key = enc.Base64.parse(intToken);
            const iv = lib.WordArray.random(16);

            const encryptedData = AES.encrypt(deviceSerialNumber, key, {
                iv,
                padding: ZeroPadding,
            });

            const convertWordArrayToUint8Array = (wordArray) => {
                const len = wordArray.words.length;
                const u8_array = new Uint8Array(wordArray.sigBytes);
                let offset = 0,
                    word,
                    i;

                for (i = 0; i < len; i++) {
                    word = wordArray.words[i];
                    u8_array[offset++] = word >> 24;
                    u8_array[offset++] = (word >> 16) & 0xff;
                    u8_array[offset++] = (word >> 8) & 0xff;
                    u8_array[offset++] = word & 0xff;
                }
                return u8_array;
            };

            const saltByteArray = Buffer.from(convertWordArrayToUint8Array(iv));
            const deviceSerialNumberByteArray = Buffer.from(convertWordArrayToUint8Array(encryptedData.ciphertext));
            const resultByteArray = Buffer.concat([saltByteArray, deviceSerialNumberByteArray]);

            const encryptedDeviceSerialNumber = resultByteArray.toString('base64');

            const preparedEncryptedDeviceSerialNumber = encodeURI(encryptedDeviceSerialNumber);

            return preparedEncryptedDeviceSerialNumber;
        } catch (e) {
            log.error(`cryptoService: encryptDeviceSerialNumber, error: ${e}`);
        }
    }

    return null;
};

export default {
    encryptDeviceSerialNumber,
};
